import { Link } from 'react-router-dom';
import { Product } from '@/mocks/products';

interface ProductGridProps {
  products: Product[];
}

export default function ProductGrid({ products }: ProductGridProps) {
  if (products.length === 0) {
    return (
      <div className="text-center py-20">
        <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-200">
          <i className="ri-shopping-bag-3-line text-2xl text-foreground-400"></i>
        </div>
        <p className="text-foreground-500 text-sm">暂无商品</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
      {products.map((product) => (
        <Link
          key={product.id}
          to={`/category/${product.category}`}
          className="group bg-background-50 rounded-xl overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
          data-product-shop
        >
          <div className="relative aspect-square overflow-hidden bg-background-200">
            <img
              src={product.image}
              alt={product.name}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              title={product.name}
            />
            {product.badge && (
              <span className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-full font-medium">
                {product.badge}
              </span>
            )}
          </div>
          <div className="p-3">
            <p className="text-xs text-foreground-500 mb-1">{product.brand}</p>
            <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug mb-2 group-hover:text-primary-500 transition-colors duration-200">
              {product.name}
            </h3>
            <div className="flex items-baseline gap-1.5">
              <span className="text-base font-bold text-primary-500">¥{product.price}</span>
              <span className="text-xs text-foreground-400 line-through">¥{product.originalPrice}</span>
            </div>
            <div className="flex items-center gap-1 mt-1">
              <div className="flex text-accent-500 text-xs">
                <i className="ri-star-fill"></i>
              </div>
              <span className="text-xs text-foreground-500">{product.rating}</span>
              <span className="text-xs text-foreground-400 ml-auto">
                已售{product.sales > 10000 ? `${(product.sales / 10000).toFixed(1)}万` : product.sales}
              </span>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}